import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import i18n from './i18n'
import './assets/scss/element-variables.scss'
import './assets/scss/styles.scss'
import util from './util'

Vue.config.productionTip = false

Vue.mixin({
  data() {
    return {
      that: this
    }
  },
  filters: {
    dateFormat(date, vm) {
      if(date){
        let lang = vm.$i18n.locale
        const langMap={
          en: 'en-GB',
          cn: 'zh-CN',
          tc: 'zh-HK',
          jap: 'ja-JP',
          ko: 'ko'
        }
        return vm.$d(util.dateArr(date), 'short', langMap[lang])
      }
      else {
        return date
      }
    }
  },
});


new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
